import cookieMatch from '@finn-no/distribution-cookiematch';

export default {
    dependencies: ['sitesettings'],
    callable(sitesettings) {
        cookieMatch({
            wwwSite: sitesettings.wwwSite,
            source: 'mfinn',
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/matchingCookie.js